/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const ArrowsMaximizeSolidV6 = (props) => (
  <Icon {...props} name="Arrows Maximize Solid V6">
    <path d="M14 7a1 1 0 0 0 1-1V2a.996.996 0 0 0-1-1h-4a1 1 0 1 0 0 2h1.586L8 6.588 4.416 3.001H6a1 1 0 1 0 0-2H2a.996.996 0 0 0-1 1v4a1 1 0 1 0 2 0V4.417l3.588 3.584-3.587 3.587v-1.587a1 1 0 1 0-2 0v4a.996.996 0 0 0 1 1h4a1 1 0 1 0 0-2H4.417l3.584-3.584 3.587 3.584h-1.587a1 1 0 1 0 0 2h4a.996.996 0 0 0 1-1v-4a1 1 0 1 0-2 0v1.586L9.417 8.001l3.584-3.584v1.584a1 1 0 0 0 1 1z" />
  </Icon>
);

export default ArrowsMaximizeSolidV6;
